export const K1_DOC = 'k1_doc';
export const FARM_UPDATE_DOC = 'farm_update_doc';
export const FARM_FINANCIAL_STATEMENTS_DOC = 'farm_financial_statements';
